import $ from 'jquery';
import FAQ from './FAQ';

export default function () {
  const $faq_elements = $('[data-qa-block][data-initialized!=true]');
  if ($faq_elements.length === 0) {
    return;
  }

  $faq_elements.each((i, el) => {
    const $el = $(el);

    new FAQ($el);
    $el.attr('data-initialized', true);
  });

  $(document).on('click', '[data-select-topic]', (e) => {
    const $select_topic_button = $(e.currentTarget);
    $select_topic_button.toggleClass('State--active');
    $select_topic_button.next().slideToggle(400);
  });

  $('[data-nav-item]').on('click', function(e) {
    if (window.theme.breakpoints.current === 'mobile') {
      $('[data-select-topic]').removeClass('State--active');
      $('[data-faq-nav-container]').slideUp(400);
    }
    if (this.hash !== '') {
      e.preventDefault();
      const hash = this.hash;
      if (window.theme.breakpoints.current === 'mobile') {
        $('html, body').animate({
          scrollTop: $(hash).offset().top - 250,
        }, 800);
      } else {
        $('html, body').animate({
          scrollTop: $(hash).offset().top - 120,
        }, 800);
      }
    }
  });
}
